export default {
  data() {
    return {
      searchSchema: [
        {
          label: '运行时间',
          type: 'rangePicker',
          itemName: 'date',
          format: 'YYYY-MM-DD',
          allowClear: true,
        },
      ],
      searchForm: {
        date: [],
      },
      pageData: {
        pageSize: 10,
        current: 1,
        total: 0,
        showTotal: total => `共${total}条`,
      },
      tableData: [],
      tableColumns: [
        {
          fixed: 'left',
          title: '序号',
          width: 60,
          customRender: (text, record, index) => {
            return (
              (this.pageData.current - 1) * this.pageData.pageSize + index + 1
            )
          },
        },
        {
          title: '记录编号',
          width: 210,
          dataIndex: 'id',
        },
        {
          title: '运行时间',
          width: 200,
          dataIndex: 'runTime',
        },
        {
          title: '评分卡名称',
          width: 220,
          dataIndex: 'scoreTypeName',
        },
        {
          title: '业务类型',
          width: 180,
          dataIndex: 'businessName',
        },
        {
          title: '业务模式',
          width: 180,
          dataIndex: 'modelName',
        },
        {
          title: '信用主管',
          width: 180,
          dataIndex: 'creditManager',
        },
        {
          title: '财报年份',
          width: 180,
          dataIndex: 'financeTime',
        },
        {
          title: '操作人',
          width: 180,
          dataIndex: 'operator',
        },
        {
          title: '状态查看',
          width: 180,
          dataIndex: 'statusStr',
        },
        {
          title: '操作',
          width: 100,
          fixed: 'right',
          scopedSlots: { customRender: 'action' },
        },
      ],
    }
  },
  methods: {
    // 查询
    handleSearch(data) {
      this.searchForm = { ...this.searchForm, ...data }
      this.pageData.current = 1
      this._getTableData()
    },
    // 点击分页按钮
    handleClickPage({ current, pageSize }) {
      this.pageData = { ...this.pageData, current, pageSize }
      this._getTableData()
    },
  },
}
